import { WEB_SCHEMA } from '../../../constants/componentStaticData';
import { Meta } from '../../../layout/Meta';
import { AuthorPostList } from '../AuthorDetail';
import { AuthorLayout } from '../AuthorLayout';
import { IAUTHOR_PAGINATED_POSTS, IGET_AUTHOR_POST_LAYOUT } from '../types';
import { getAuthorSEODetails } from '../utils/authorPostListUtils';

export const AuthorPostListPage = ({
  data,
  authorName,
}: IGET_AUTHOR_POST_LAYOUT) => {
  const authorData = data as IAUTHOR_PAGINATED_POSTS;
  const seoDetails = getAuthorSEODetails(
    authorName,
    authorData.author_details.slug,
    authorData.author_details.designation,
    authorData.author_details.description
  );

  return (
    <AuthorLayout
      showAuthorDetail={true}
      authorData={authorData.author_details}
    >
      <Meta
        title={seoDetails.title}
        description={seoDetails.metaDesc}
        canonical={seoDetails.url}
        key="robots"
      />
      <AuthorPostList data={authorData} authorName={authorName} />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(
            WEB_SCHEMA({
              ...seoDetails,
            })
          ),
        }}
      ></script>
    </AuthorLayout>
  );
};
